import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "evolution_triangle",
  "use": "evolution_triangle-usage",
  "viewBox": "0 0 7 6",
  "content": "<symbol viewBox=\"0 0 7 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"evolution_triangle\">\n<path d=\"M2.66137 1.29115C3.05567 0.684093 3.94433 0.684092 4.33863 1.29115L6.3938 4.45529C6.8259 5.12057 6.34846 6 5.55517 6H1.44483C0.651541 6 0.174095 5.12057 0.606201 4.4553L2.66137 1.29115Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol